<template>
  <div>
    <el-card header="活动详情" class="box-card">
      <h1>{{viewData.title}}</h1>
      <h2>发布时间：{{viewData.publishDate}} &nbsp;&nbsp;&nbsp;&nbsp; 浏览量：{{viewData.viewer}}</h2>
      <div v-html="viewData.content"></div>
    </el-card>

  </div>
</template>
<script>
export default {
  data () {
    return {
      formData: {
        id: undefined,
        title: '',
        icon: '',
        startDate: '',
        endDate: '',
        content: '',
        url: '',
        publishDate: '',
        viewer: undefined
      }
    }
  },
  created: function () {
    this.formData.id = this.$route.params.id
    if (this.formData.id) { this.fetchData() }
  },
  methods: {
    fetchData () {
      var that = this
      that.api.activity.get({ id: that.formData.id }).then(response => {
        if (response.data.success) {
          Object.assign(that.formData, response.data.result)
        }
      })
    }
  },
  computed: {
    viewData: function () {
      return this.activity ? this.activity : this.formData
    }
  },
  props: {
    activity: { type: Object, required: false }
  }
}
</script>
<style scoped>
h1{
  text-align: center;
  font-weight: normal;
  font-size: 16px;
}
h2{
  text-align: center;
  font-weight: normal;
  font-size: 12px;
}
div{
  line-height: 30px;
  font-size: 14px;
  text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// View.vue?653154ea